module.exports = __webpack_public_path__ + "static/media/pro-vouchar.10d7710c.png";